import React from 'react';
import s from './style.css';
const FileLabel = ({ file, small }) => {
    const cut = small ? 4 : 8;
    const extension = file.name?.split('.').pop()?.split(' ')[0].toUpperCase().slice(0, cut);
    const size = small ? 32 : 100;
    const fontSize = small ? '10px' : '15px';
    return (React.createElement("div", { className: s.extensionContainer, style: { width: size, height: size } },
        React.createElement("p", { style: { fontSize } }, extension)));
};
export default FileLabel;
